import React, { useState, useEffect } from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import { graphql } from "gatsby"
import FiltersHeader from "../components/FiltersHeader"
import VideoList from "../components/VideoList"

const VideosPage = ({ data }) => {
  const [filters, setFilters] = useState([])
  const [activeFilter, setActiveFilter] = useState({ value: 'All' })
  const [hasMounted, setHasMounted] = useState(false)


  useEffect(() => {
    const getFilters = () => {
      let filters = []
      data.allVideos.nodes.forEach(d => {
        d.filters.forEach(f => {
          if (filters.indexOf(f.label) === -1) {
            filters.push(f.label)
          }
        })
      })
      setFilters(filters)
    }
    getFilters()
    setHasMounted(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!hasMounted) {
    return (
      <Layout contentTopMargin noBreadcrumb>
        <Seo title="Videos" />
      </Layout>
    )
  }

  return (
    <Layout contentTopMargin noBreadcrumb>
      <Seo title="Videos" />
      <FiltersHeader title="Videos" filters={filters} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
      <VideoList selectedFilter={activeFilter.value} videos={data.allVideos.nodes} />
    </Layout>
  )
}

export default VideosPage

export const query = graphql`
  query {
    allVideos(sort: {order: DESC, fields: publish_date}) {
      nodes {
        id
        title
        publish_date
        publish_time
        description
        video_url
        filters {
          label
        }
      }
    }
  }
`
